module.exports = __webpack_public_path__ + "media/images/pla/pla23-f2ad040f895c60748d002f305ff08b99.jpg";